module.exports = __webpack_public_path__ + "media/img/vca/winner4-94397394833bc6af5fd7dd919f97b798.png";